'use client'
import React, { useState } from 'react';

import { Button } from '../Button/Button';
import { Icon } from '../Icon/Icon';
import Link from 'next/link';

export type PhoneButtonProps = {
  /** Phone number */
  number: string,
  className?: string
}

/** Primary UI component for user interaction */
export const PhoneButton = ({
  number,
  className
}: PhoneButtonProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {!open && <Button className={className} onClick={() => setOpen(true)}><>Afficher le numéro <Icon icon='phone'/></></Button>}
      {open && <Button className={className} asChild><Link href={`tel:${number}`}>{number} <Icon icon='phone'/></Link></Button>}
    </>
  )
};
